<template>
    <!-- <a-spin :spinning="spinning" class="spin-box" :tip="$t('spin.text')"> -->
        <v-form
            ref="emailForm"
            v-model="valid"
            class="form-box formStyle">
            <v-text-field
                v-if="dataType"
                v-model="form.password"
                outlined
                required
                :append-icon="isPwdVisible1 ? icons.mdiEyeOutline : icons.mdiEyeOffOutline"
                dense
                :error-messages="errorMessage"
                :type="isPwdVisible1 ? 'text' : 'password'"
                :label="$t('account.pwd')"
                :placeholder="$t('account.pwdPlaceholder')"
                hide-details="auto"
                :rules="emailFormRule.password"
                class="mb-6"
                @click:append="isPwdVisible1 = !isPwdVisible1"
            ></v-text-field>
            <v-text-field
                v-model="form.email"
                outlined
                required
                dense
                :error-messages="emailErrMsg"
                :label="$t('account.ema')"
                :placeholder="$t('account.emailPlaceholder')"
                hide-details="auto"
                :rules="emailFormRule.email"
                class="mb-6"
            ></v-text-field>
            <v-row no-gutters>
                <v-col cols="8" md="8" lg="8" xl="8" sm="12 ">
                    <v-text-field
                        v-model="form.code"
                        outlined
                        required
                        dense
                        :label="$t('account.code')"
                        :placeholder="$t('account.codePlaceholder')"
                        hide-details="auto"
                        :rules="emailFormRule.code"
                        class="mb-6"
                    >
                    </v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" md="3" lg="3" xl="3" sm="12"  class="code-box   d-flex mb-2 justify-end align-baseline" :class="codeText == $t('account.getCode')?'cursor-pointer':'text'" @click="getCode">
                    <v-btn small outlined v-if="codeText == $t('account.getCode')" color="primary" min-height="40" style="width:118%">{{codeText}}</v-btn>
                    <v-btn small outlined v-else style="width:100%" disabled min-height="40">{{codeText+'s'}}</v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="mb-2">
                    <v-btn color="primary" @click="onSubmit" small>{{$t('btn.submit')}}</v-btn>
                    <v-btn class="close_btn" outlined @click="close" small>{{$t('btn.close')}}</v-btn>
                </v-col>
            </v-row>
        </v-form>
    <!-- </a-spin> -->
</template>

<script>
import { bindEmail, updateEmail, sendEmail, emailCheckPwd } from "@/api/index";
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
import { emailValidator } from '@core/utils/validation'
import store from '@/store'

export default {
    data() {
        return {
            valid: false,
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            isPwdVisible1:false,
            icons: {
                mdiEyeOutline,
                mdiEyeOffOutline
            },
            errorMessage: undefined,
            emailErrMsg: undefined,
            form: {},
            emailValidator,
            emailFormRule:
                {
                    password: [
                        v => !!v || this.$t('account.pwdPlaceholder'),
                        // v => validatePass(v)
                    ],
                    email: [
                        v => !!v || this.$t('account.emailPlaceholder'),
                    ],
                    code: [
                        v => !!v || this.$t('account.codePlaceholder'),
                        v => (/^[0-9]{6}$/.test(v)) || this.$t('account.code6')
                    ],
                },
            codeText: this.$t('account.getCode'),
            spinning: false
        };
    },
    props: {
        dataType: Boolean
    },
    created() {
        self = this
    },
    watch: {
        'form.password': (val,old) => {
            if(val) {
                self.validatePass(val)
            }
        },
        'form.email': (val,old) => {
            self.emailErrFun(val)
        }
    },
    mounted() {
        this.$root.eventHub.$on('handleCancel3', ()=> {
            this.$refs.emailForm.resetValidation();
            this.$root.eventHub.$off("handleCancel3")
        })
    },
    methods: {
        onSubmit() {
            if(this.$refs.emailForm.validate()){
                let apiType = this.dataType ? updateEmail : bindEmail
                let params = {}
                this.$passwordEncryption(this.form.password).then(password=> {
                    if (this.dataType) {
                        params = {
                            email: this.form.email,
                            vCode: this.form.code,
                            pwd: password
                        }
                    } else {
                        params = {
                            email: this.form.email,
                            vCode: this.form.code
                        }
                    }
                    apiType(params).then(res=> {
                        if (res.code == this.$GLOBA.StatusOK) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'success'
                            })
                            this.$emit("onSubmit")
                        }else{
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'error'
                            })
                        }
                    })
                })
            }
        },
        close() {
            this.$emit("close")
        },
        getCode() {
            // let list = this.dataType ? ['password', 'email'] : ['email']
            // let num = 0
            if(this.dataType){
                this.emailErrFun(this.form.email)
                this.validatePass(this.form.password)
            }else{
                this.emailErrFun(this.form.email)
            }
            if(this.emailErrMsg != undefined && this.errorMessage != undefined) {
                return
            }
            // this.$refs.emailForm.validateField(list, valid => {
            //     if (!valid) {
            //         num ++
            //     }
            // })
            // if(this.codeText == this.$t('account.getCode') && num == list.length) {
            if(this.codeText == this.$t('account.getCode') && this.form.email && this.form.password && this.dataType || this.codeText == this.$t('account.getCode') && this.form.email && !this.dataType) {
                this.spinning = true
                // 0、修改绑定邮箱；1、邮件验证码；2、重置密码；3：重置密码确认
                let params = null
                let apiType = null
                this.$passwordEncryption(this.form.password).then(password=> {
                    if (this.dataType) {
                        params = {
                            email: this.form.email,
                            emailType: this.dataType ? this.$getEmailModel('editEmail') : this.$getEmailModel('bind'),
                            pwd: password
                        }
                        apiType = emailCheckPwd
                    } else {
                        params = {
                            email: this.form.email,
                            emailType: this.dataType ? this.$getEmailModel('editEmail') : this.$getEmailModel('bind'),
                        }
                        apiType = sendEmail
                    }
                    apiType(params).then(res=> {
                        this.spinning = false
                        if (res.code == this.$GLOBA.StatusOK) {
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'success'
                            })
                            this.codeText = 60
                            let timer = setInterval(()=>{
                                this.codeText--
                                if(this.codeText <= 0) {
                                    clearInterval(timer)
                                    this.codeText = this.$t('account.getCode')
                                }
                            },1000)
                        }else{
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'error'
                            })
                        }
                    }).catch(err=> {
                        this.spinning = false
                    })
                })
            }
        },
        validatePass(v) {
            if(!v){
                this.errorMessage = this.$t('account.pwdPlaceholder')
            }else if(this.$checkPassword(v)){
               // this.errorMessage = this.$checkPassword(v) == true ? undefined : this.$checkPassword(v)
            }else {
                this.errorMessage = undefined
            }
        },
        emailErrFun(v) {
            if (!v) {
                this.emailErrMsg = this.$t('login.retrieveEmail.email')
            } else if(this.emailValidator(v)) {
                this.emailErrMsg = this.emailValidator(v) == true ? undefined : this.emailValidator(v)
            } else {
                this.emailErrMsg = undefined
            }
        }
    },
};
</script>

<style scoped lang="scss">
::v-deep .ant-input-group-addon {
    min-width: 93px;
    background: none;
}
.get-code {
    cursor: pointer;
    color: #5066e0;
}
.code-btn ::v-deep .ant-input {
    border-right: 0;
}
::v-deep .ant-btn-round{
    margin-right: 32px;
    width: 96px;
    height: 38px;
    border-radius: 6px;
    background: #5066e0;
    font-size: 18px;
}
::v-deep .ant-modal-title{
    line-height: 29px;
    margin-left: 16px;
    font-size: 18px;
}
::v-deep .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled){
    border-color: #5066e0;
}
.formStyle{
    width: 70%;
    margin-left: 15%;
}
::v-deep .row {
    align-items: start !important;
}
.close_btn{
    margin-left: 10px;
}

.code-box ::v-deep {
      .v-btn.theme--dark {
        border-color: rgba(231, 227, 252, 0.28) !important;
        .v-btn__content{
          color:rgba(231, 227, 252, 0.67);
        }
      }
 }

  @media screen and (min-width: 320px) and (max-width: 480px){
    .close_btn{
      margin-left: 6px;
    }
    ::v-deep {
      .v-text-field.v-text-field--enclosed .v-text-field__details{
        padding: 0;
      }
    }
    .formStyle{
      width: 100%;
      margin-left: 0%;
      margin-top: 10px;

    }

}
</style>
